import styled from 'styled-components';
import _SurfaceRolesDropdown from 'components/canvas/components/top-left-menu/components/share-surface-button/components/share-surface-modal/components/email-autocomplete/components/surface-roles-dropdown';
import { Row } from 'components/layout';
import { ReactComponent as Delete } from 'styles/icons/delete-icon.svg';
import { normalize, withModifiers } from 'utils/styles';
import { color, typography } from 'styles/settings';

export const FirstName = styled.span`
  ${typography.font.content.semiBold};
  font-size: ${typography.size.md};
  line-height: ${typography.size.ml};
  margin-bottom: ${normalize('6px')};
`;

export const LastName = styled.span`
  ${typography.font.content.regular};
  font-size: ${typography.size.md};
  line-height: ${typography.size.ml};
`;

export const RoleLabel = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border: ${normalize('2px')} solid ${color.neutral.grayLight};
  border-radius: ${normalize('10px')} 0px;
  cursor: default;
  padding: ${normalize('15px')} ${normalize('20px')};
  color: ${color.neutral.plainBlack};
  ${typography.font.content.semiBold};
  font-size: ${typography.size.md};
  line-height: ${typography.size.ml};
  ${withModifiers('withCursor')`
    cursor: pointer;
  `}
`;

export const DeleteRoleLabel = styled(RoleLabel)`
  &:hover {
    color: ${color.ui.danger};
    border-color: ${color.ui.danger};
  }
  &:active {
    opacity: 0.6;
  }
`;

export const UserRow = styled(Row)`
  margin-bottom: ${normalize('32px')};
`;

export const DeleteIcon = styled(Delete)`
  height: ${normalize('20px')};
  width: ${normalize('18px')};
  &:hover {
    color: ${color.ui.danger};
  }
`;

export const SurfaceRolesDropdown = styled(_SurfaceRolesDropdown)`
  color: ${color.neutral.plainBlack};
  background-color: ${color.neutral.white};
  padding: 0;
`;
